import React from "react";

const Icons = () => (
  <svg style={{ display: "none" }} aria-hidden="true">
    <defs>
      <linearGradient id="gGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F5B041" />
        <stop offset="100%" stopColor="#E59C2E" />
      </linearGradient>

      <g id="home-blob-1" transform="translate(-100,-100)">
        <path d="M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z" />
        <path d="M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z" />
      </g>

      <g id="home-blob-2" transform="translate(100,-100) scale(-1,1)">
        <path d="M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z" />
        <path d="M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z" />
      </g>
    </defs>

    <symbol id="icon-cert" viewBox="0 0 48 56">
      <rect
        x="6"
        y="2"
        width="36"
        height="32"
        rx="3"
        fill="#F5B041"
        fillOpacity=".15"
        stroke="#C4841D"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <rect x="14" y="8" width="20" height="6" rx="1.5" fill="#C4841D" />
      <line
        x1="12"
        y1="20"
        x2="36"
        y2="20"
        stroke="#C4841D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="16"
        y1="26"
        x2="32"
        y2="26"
        stroke="#C4841D"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity=".5"
      />
      <path
        d="M18 46l-4 9 3-1.5 1.5 3 3-8"
        fill="#C4841D"
        fillOpacity=".6"
        stroke="#C4841D"
        strokeWidth="1"
        strokeLinejoin="round"
      />
      <path
        d="M30 46l4 9-3-1.5-1.5 3-3-8"
        fill="#C4841D"
        fillOpacity=".6"
        stroke="#C4841D"
        strokeWidth="1"
        strokeLinejoin="round"
      />
      <circle cx="24" cy="40" r="11" fill="#FAFAFE" />
      <circle
        cx="24"
        cy="40"
        r="9"
        fill="#F5B041"
        fillOpacity=".25"
        stroke="#C4841D"
        strokeWidth="2.5"
      />
      <circle
        cx="24"
        cy="40"
        r="5.5"
        fill="none"
        stroke="#C4841D"
        strokeWidth="1.5"
      />
      <path
        d="M21 40l2 2 4-4"
        fill="none"
        stroke="#C4841D"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </symbol>

    <symbol id="icon-experts" viewBox="0 0 48 48">
      <circle
        cx="24"
        cy="14"
        r="7"
        fill="#F5B041"
        fillOpacity=".12"
        stroke="#C4841D"
        strokeWidth="2.5"
      />
      <circle
        cx="13"
        cy="17"
        r="5.5"
        fill="#F5B041"
        fillOpacity=".12"
        stroke="#C4841D"
        strokeWidth="2.5"
      />
      <circle
        cx="35"
        cy="17"
        r="5.5"
        fill="#F5B041"
        fillOpacity=".12"
        stroke="#C4841D"
        strokeWidth="2.5"
      />
      <path
        d="M8 38c0-6 4-10 10-10h12c6 0 10 4 10 10"
        fill="none"
        stroke="#C4841D"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M2 40c0-5 3-8 7-9"
        fill="none"
        stroke="#C4841D"
        strokeWidth="2"
        strokeLinecap="round"
        opacity=".5"
      />
      <path
        d="M46 40c0-5-3-8-7-9"
        fill="none"
        stroke="#C4841D"
        strokeWidth="2"
        strokeLinecap="round"
        opacity=".5"
      />
    </symbol>

    <symbol id="icon-ondemand" viewBox="0 0 48 48">
      <path
        d="M8 10h24a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H18l-8 6v-6H8a4 4 0 0 1-4-4V14a4 4 0 0 1 4-4z"
        fill="#F5B041"
        fillOpacity=".15"
        stroke="#C4841D"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M14 20l4 4 8-8"
        fill="none"
        stroke="#C4841D"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="36" cy="34" r="8" fill="#FAFAFE" />
      <circle
        cx="36"
        cy="34"
        r="7"
        fill="#F5B041"
        fillOpacity=".2"
        stroke="#C4841D"
        strokeWidth="2.5"
      />
      <path
        d="M36 30v4l3 2"
        fill="none"
        stroke="#C4841D"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </symbol>

    <symbol id="icon-ai" viewBox="0 0 48 48">
      <path
        d="M22 10l3.5 10.5 10.5 3.5-10.5 3.5L22 38l-3.5-10.5L8 24l10.5-3.5z"
        fill="#C4841D"
        stroke="#C4841D"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M40 4l1 3.5L44.5 8.5l-3.5 1L40 13l-1-3.5L35.5 8.5l3.5-1z"
        fill="#C4841D"
        stroke="#C4841D"
        strokeWidth="1"
        strokeLinejoin="round"
      />
      <path
        d="M36 36l1 3.5L40.5 40.5l-3.5 1L36 45l-1-3.5L31.5 40.5l3.5-1z"
        fill="#C4841D"
        stroke="#C4841D"
        strokeWidth="1"
        strokeLinejoin="round"
      />
    </symbol>

    <symbol id="icon-sparkle" viewBox="0 0 24 24">
      <path
        d="M10 8l1.5 5L16.5 14.5l-5 1.5L10 21l-1.5-5L3.5 14.5l5-1.5z"
        fill="#C4841D"
        stroke="#C4841D"
        strokeWidth=".5"
        strokeLinejoin="round"
      />
      <path
        d="M20 1l.5 1.8 1.8.5-1.8.5L20 5.6l-.5-1.8-1.8-.5 1.8-.5z"
        fill="#C4841D"
      />
      <path
        d="M20 15l.5 1.5 1.5.5-1.5.5L20 19l-.5-1.5-1.5-.5 1.5-.5z"
        fill="#C4841D"
      />
    </symbol>

    <symbol id="icon-gift" viewBox="0 0 36 36">
      <rect
        x="5"
        y="18"
        width="26"
        height="14"
        rx="2"
        fill="#F5B041"
        fillOpacity=".12"
        stroke="#C4841D"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <rect
        x="3"
        y="12"
        width="30"
        height="7"
        rx="2"
        fill="#F5B041"
        fillOpacity=".12"
        stroke="#C4841D"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <line
        x1="18"
        y1="12"
        x2="18"
        y2="32"
        stroke="#C4841D"
        strokeWidth="2.5"
      />
      <ellipse
        cx="14"
        cy="9"
        rx="4.5"
        ry="3.5"
        fill="none"
        stroke="#C4841D"
        strokeWidth="3"
      />
      <ellipse
        cx="22"
        cy="9"
        rx="4.5"
        ry="3.5"
        fill="none"
        stroke="#C4841D"
        strokeWidth="3"
      />
      <circle cx="18" cy="10" r="2.5" fill="#C4841D" />
    </symbol>
  </svg>
);

export default Icons;
